module.exports = __webpack_public_path__ + "static/media/budget.7de8166c.svg";